import React, { useState, useEffect } from 'react';
import Navbar from '../shared/Navbar';
import CourseSelector from './CourseSelector';
import { api } from '../../services/api';

function BrowsePage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.me()
      .catch(() => {})
      .then(() => setLoading(false));
  }, []);

  // Don't render until we know the auth state to prevent layout shift
  if (loading) {
    return <div className="app"><div className="app-loading" /></div>;
  }

  return (
    <div className="app">
      <Navbar />
      <main className="app-main browse-page-main">
        <div className="content-container browse-page-container">
          <CourseSelector />
        </div>
      </main>
    </div>
  );
}

export default BrowsePage;
